export const roundingList = [
  { name: "No Rounding", value: "38f5d966-766c-11e9-87b9-0242ac120002" },
  { name: "1/10th (1 decimal)", value: "c0059aaf-8897-11e9-93c5-00155ddd690a" },
  { name: "1/100th (2 decimals)", value: "1e2bd52a-766e-11e9-87b9-0242ac120002" },
  { name: "1/1,000th (3 decimals)", value: "2dc24865-766e-11e9-87b9-0242ac120002" },
  { name: "1/10,000th (4 decimals)", value: "3a62b842-766e-11e9-87b9-0242ac120002" },
  { name: "1/8th", value: "4a92ede9-766e-11e9-87b9-0242ac120002" },
  { name: "1/16th", value: "5a08327b-766e-11e9-87b9-0242ac120002" },
  { name: "1/32nd", value: "663f1525-766e-11e9-87b9-0242ac120002" },
  { name: "1/64th", value: "765f2177-766e-11e9-87b9-0242ac120002" }
];
export default {
  ONE_THOUSANDTH: "2dc24865-766e-11e9-87b9-0242ac120002",
  ONE_THIRTY_SECOND: "663f1525-766e-11e9-87b9-0242ac120002",
  ONE_THIRTY_SECOND: "765f2177-766e-11e9-87b9-0242ac120002",
  ONE_TEN_THOUSANDTH: "3a62b842-766e-11e9-87b9-0242ac120002",
  ONE_SIXTEENTH: "5a08327b-766e-11e9-87b9-0242ac120002",
  ONE_HUNDREDTH: "1e2bd52a-766e-11e9-87b9-0242ac120002",
  ONE_EIGHTH: "4a92ede9-766e-11e9-87b9-0242ac120002",
  ONE_TENTH: "c0059aaf-8897-11e9-93c5-00155ddd690a",
  NO_ROUNDING: "38f5d966-766c-11e9-87b9-0242ac120002"
};

